export default __webpack_public_path__ + "static/media/moon-solid.cf7a6d04.svg";